import { Component, OnInit, Input, inject } from '@angular/core';
import { AppConfig } from "app/app.config";
import { LoaderService } from "app/services/loader.service";
import { APIService } from 'app/services/api.service';
import { DatePipe } from '@angular/common';

type NewsType = {
  Id: number;
  newstitle: string;
  newsimage: string;
  newssummary: string;
  newslink: string;
  newsdate: string;
}

@Component({
    selector: 'news',
    templateUrl: `./news.component.html`,
    styleUrls: ['./news.component.scss'],
    imports: [DatePipe]
})

export class NewsComponent implements OnInit {
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);
  private api = inject(APIService);

  @Input() topic: string = 'PGF';
  @Input() limit: number = 120;
  public data:NewsType[] = [];
  public data2show:NewsType[] = [];
  public shownLimit = 16;

  ngOnInit() {
    this.getNews();
  }

  getNews() {
    this.loaderService.display(true, 'News');
    this.api.get<NewsType[]>(`${this.config.pgf.getNewsUrl}/${this.topic}/${this.limit}`).subscribe({
      next: res => {
        this.loaderService.display(false, 'News');
        this.data = res;
        this.data2show = this.data.slice(0,this.shownLimit);
      },
      error: () => this.loaderService.display(false, 'News')
    });
  }

  loadMore() {
    this.shownLimit+=16;
    this.data2show = this.data.slice(0,this.shownLimit);
  }
}